import React from 'react';
import styles from './styles/buttons.module.css';

class BigBtn extends React.Component {
  render() {
    return (
      <div className={styles.bigBtn} onClick={this.props.onClick}>
        {this.props.title}
      </div>
    );
  }
}

export default BigBtn;
